import React, { useEffect, useState, useRef } from 'react';
import axios from 'axios';
import Portability_Drawl_Afso from './Portability_Drawl_Afso';
import progressGif from '../../images/progress.gif';

const Portability_Drawl_District = ({ month, year, excludeFpsId }) => {
  const [districtData, setDistrictData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedDistrict, setSelectedDistrict] = useState(null);
  const [afsoLoading, setAfsoLoading] = useState(false);
  const afsoRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_URL_SALE}/api/portabilityDrawl/districtDrwal`,
          { params: { month, year, excludeFpsId } }
        );
        setDistrictData(response.data);
      } catch (err) {
        console.error(err);
        setError(err);
      } finally {
        setLoading(false);
      }
    };
    if (month && year) fetchData();
  }, [month, year, excludeFpsId]);

  const handleDistrictClick = (district) => {
    if (selectedDistrict === district) {
      setSelectedDistrict(null);
    } else {
      setAfsoLoading(true);
      setSelectedDistrict(district);

      setTimeout(() => {
        setAfsoLoading(false);
      }, 3000);
    }
  };

  useEffect(() => {
    if (!afsoLoading && selectedDistrict && afsoRef.current) {
      setTimeout(() => {
        afsoRef.current.scrollIntoView({ behavior: 'smooth', block: 'start' });
      }, 100);
    }
  }, [afsoLoading, selectedDistrict]);

  if (loading)
    return <div style={{ textAlign: 'center', marginTop: '20px' }}>Loading...</div>;

  if (error)
    return (
      <div style={{ textAlign: 'center', color: 'red', fontWeight: 'bold', fontSize: '20px', marginTop: '20px' }}>
        Invalid Request (Exception)
      </div>
    );

  if (!districtData || districtData.length === 0)
    return (
      <div style={{ textAlign: 'center', color: 'red', fontWeight: 'bold', fontSize: '20px', marginTop: '20px' }}>
        No Data Found
      </div>
    );

  const monthNames = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"];
  const monthName = monthNames[month - 1];

  const totals = districtData.reduce((acc, item) => {
    acc.totalCards += item.totalCards || 0;
    acc.drawlRC += item.drawlRC || 0;
    acc.wheat += item.wheat || 0;
    acc.sugar += item.sugar || 0;
    acc.frice += item.frice || 0;
    acc.sfrice += item.sfrice || 0;
    return acc;
  }, { totalCards: 0, drawlRC: 0, wheat: 0, sugar: 0, frice: 0, sfrice: 0 });

  return (
    <div style={{ marginBottom: '50px' }}>
      <table align="center" width="80%" border={1} style={{ borderCollapse: 'collapse', marginTop: '30px' }}>
        <thead>
          <tr className='tableheader'>
            <th colSpan={8}>DISTRICT WISE UNIQUE RC and SALE DETAILS - {monthName} '{year}</th>
          </tr>
          <tr className="tableheader">
            <th rowSpan={2} style={{ textAlign: 'left', paddingLeft: '8px' }}>Sl. No</th>
            <th rowSpan={2}>District</th>
            <th rowSpan={2}>Total Cards</th>
            <th rowSpan={2}>Drawl Cards</th>
            <th colSpan={4}>Total Drawl Qty (Kg)</th>
          </tr>
          <tr className="tableheader">
            <th>Wheat</th>
            <th>Sugar</th>
            <th>Fortified Sannabiyyam</th>
            <th>S-Fortified Sannabiyyam</th>
          </tr>
        </thead>
        <tbody>
          {districtData.map((item, index) => (
            <tr key={index}>
              <td style={{ textAlign: 'left', paddingLeft: '8px' }}>{index + 1}</td>
              <td style={{ textAlign: 'left' }}>
                <a
                  href="#"
                  style={{ color: 'blue', textDecoration: 'underline', cursor: 'pointer' }}
                  onClick={() => handleDistrictClick(item.district)}
                >
                  {item.district}
                </a>
              </td>
              <td style={{ textAlign: 'right' }}>{item.totalCards}</td>
              <td style={{ textAlign: 'right' }}>{item.drawlRC}</td>
              <td style={{ textAlign: 'right' }}>{item.wheat}</td>
              <td style={{ textAlign: 'right' }}>{item.sugar}</td>
              <td style={{ textAlign: 'right' }}>{item.frice}</td>
              <td style={{ textAlign: 'right' }}>{item.sfrice}</td>
            </tr>
          ))}

          <tr className='tableheader'>
            <td colSpan={2} style={{ textAlign: 'center' }}>Total</td>
            <td style={{ textAlign: 'right' }}>{totals.totalCards}</td>
            <td style={{ textAlign: 'right' }}>{totals.drawlRC}</td>
            <td style={{ textAlign: 'right' }}>{totals.wheat.toFixed(2)}</td>
            <td style={{ textAlign: 'right' }}>{totals.sugar.toFixed(2)}</td>
            <td style={{ textAlign: 'right' }}>{totals.frice.toFixed(2)}</td>
            <td style={{ textAlign: 'right' }}>{totals.sfrice.toFixed(2)}</td>
          </tr>
        </tbody>
      </table>

      {selectedDistrict && (
        <div style={{ marginTop: '20px' }} ref={afsoRef}>
          {afsoLoading ? (
            <div style={{ textAlign: "center", marginTop: "20px" }}>
              <img src={progressGif} alt="Loading..." width="250" height="15" />
            </div>
          ) : (
            <Portability_Drawl_Afso
              month={month}
              year={year}
              district={selectedDistrict}
              excludeFpsId={excludeFpsId}
            />
          )}
        </div>
      )}
    </div>
  );
};

export default Portability_Drawl_District;
